import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/images/restricted-area-2.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, "Unlock the Full Experience", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "welcome__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "header-sub-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return ($setup.isShowWelcomeModal)
    ? (_openBlock(), _createBlock(_component_CommonDialog, {
        key: 0,
        isShowHeader: false,
        isShowBackButton: false,
        width: "465px",
        "max-width": "100%",
        height: "auto",
        className: ['restricted__modal_box']
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", {
            class: "dashboard-welcome__close !tw-top-8 !tw-right-8",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onCloseModal && $setup.onCloseModal(...args)))
          }, [
            _createVNode(_component_v_icon, { icon: "mdi-close" })
          ]),
          _hoisted_1,
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, " This was a taste of the premium features. Create your " + _toDisplayString($setup.user.role?.name === $setup.UserRolesEnum.TRADESPERSON ? "Trade" : "Property") + " Workstation today and enjoy the full experience. ", 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: $setup.onCreateWorkstation,
            class: "button button-purple"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Create a " + _toDisplayString($setup.user.role?.name === $setup.UserRolesEnum.TRADESPERSON ? "Trade" : "Property") + " Workstation", 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}